export const socketUsersToInner = userId => (u, i) => ({
  id: i,
  place: i + 1,
  name: u.account && u.account.username,
  spins: u.spins,
  score: u.points,
  change: 0,
  self: u.accountId === userId,
});